import { Dropdown, Menu, Modal, Row, Select, Space, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URInput } from "../../../shared/widgets/input";
import styles from "./../scss/callsFrame.module.scss";
import { getCurrentCallDetail, groupSendFramer, searchTeamUsers, selectList, singleSendFramer, storeGroupParticipants, toastInformation, toastMessageCallWindow, updateOldWithNewObj, userStatusColor } from "../../../base/callService/common";
import { URButton } from "../../../shared/widgets/button";
import MemberLists from "../callsWidgets/memberList";
import { callMainPageInterface } from "../../../models/callModel";
import { useSelector } from "react-redux";
import { removeAllnMuteAll, sendAddParticipantToSocket } from "../../../base/callService/callService";
import store from "../../../context/store/store";
import { setAddCall } from "../../../base/callService/store_mining";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import callred from "../../../styles/images/nonamecall.svg";
import { SocketChatService } from "../../../base/socketChatService";
import { UserDetails } from "../../../models/model";
import deskImg from "../../../styles/images/deskphone.svg";
import waveImg from "../../../styles/images/Audio-wave.svg";
import pstnImg from "../../../styles/images/PSTN.svg";
type stateTypes = {
  searchText: string;
  allContacts: Array<any>,
  internalUsers: Array<any>,
  externalUsers: any,
  dropDowns: Array<any>,
  searchActive: string,
  isSplitView: boolean;
  openAssign: boolean;
  hostExt: string
};

export default function CallRightBar() {
  const [state, setState] = useState<stateTypes>({
    searchText: '', allContacts: [], internalUsers: [], externalUsers: [], dropDowns: [], searchActive: '', isSplitView: false, openAssign: false, hostExt: ''
  });
  let { allContacts, internalUsers, externalUsers, searchText, dropDowns, searchActive, isSplitView, openAssign, hostExt } = state;
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  let activeCallDetail: any = getCurrentCallDetail();
  let searchedList: any = searchTeamUsers(activeCallDetail, searchActive, isSplitView);
  let searchResult: any = searchedList || {};
  let groupRender = searchResult?.groupRender || {};
  let IndividualRender = searchResult?.IndividualRender || {};
  let PSTNRender = searchResult?.PSTNRender || {};
  let RenderJoined = searchResult?.RenderJoined || {};
  let RenderInvited = searchResult?.RenderInvited || {};
  let groupUserCount: number = 0;

  Object?.keys(groupRender).forEach(first => Object?.keys(groupRender[first]).forEach(second => groupUserCount++));
  let IndividualUserCount: number = Object?.keys(IndividualRender).length || 0;
  let PSTNUserCount: number = Object?.keys(PSTNRender).length || 0;
  let joinedCount: number = Object?.keys(RenderJoined).length || 0;
  let invitedCount: number = Object?.keys(RenderInvited).length || 0;

  let totalGroupParticipants: number = isSplitView ? groupUserCount + PSTNUserCount + IndividualUserCount : joinedCount + invitedCount;
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  let { isAddCall } = store.getState().updatedCallList;
  let workList = contactReducer.workContacts;
  let teamList: Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = workList.concat(teamList);

  const handleDropdowns = (keyId: any) => {
    let selection: Array<any> = selectList(dropDowns, keyId)
    setState({ ...state, dropDowns: selection });
  }

  const assignHost = (ext: any) => {
    setState({ ...state, openAssign: !openAssign, hostExt: ext });
  }
  const closeAssign = (ext: any) => {
    setState({ ...state, openAssign: !openAssign, hostExt: '' });
  }
  const directAssign = (ext: any) => {
    let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
    socketservice.updateGroupCallHost(activeCallDetail?.guid, ext);
    let assign: any = {};
    assign.TeamID = activeCallDetail?.guid;
    assign.Status = "AssignAsHost";
    assign.AssignedHost=ext;
    assign.DomainName=loggeduser.domain_name;
    assign.CurrentHost=activeCallDetail.isHostId;
    assign.DomainId=loggeduser.domain_id;

    socketservice.groupCallSendEvent(assign)
  }

  const groupCallComponent = () => {
    return Object?.keys(groupRender).map((gKey: any, index: any) => {
      let individual = groupRender[gKey];
      let isExpand = !dropDowns.includes(`G${index}`);
      return <>

        <div className={styles.listheader} >
          <div className={styles.leftconsectxt} onClick={(e: any) => handleDropdowns(`G${index}`)}>
            <span className={isExpand ? " icon_expandarrow" : "icon_uparrow"} > </span>
            {activeCallDetail?.groupNames[gKey]}
            <label className={styles.userCountno}>({Object.keys(individual).length}) </label>
          </div>


     {activeCallDetail.isGroupHost&&<div className={styles.rightmorehead}>
            <Dropdown overlay={
              <Menu className="menufiletersmute">
                <Menu.Item key={"Mute"} onClick={() => groupSendFramer('mute', true, gKey, true)}>Mute <span className={`icon_microphone righticonpro`}></span></Menu.Item>
                <Menu.Item key={"Missed"} onClick={() => groupSendFramer('Remove', true, gKey, true)}>Remove group <span className={`icon_receiverfill righticonpro`}></span></Menu.Item>
              </Menu>
            } placement="bottomRight" trigger={["hover"]} >
              <button className={styles.threedot} >
                <span className="icon_overflow-H"></span>
              </button>
            </Dropdown>
          </div>
    }

        </div>

        
        {isExpand && <ul  className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}key={index}>

        {Object?.keys(individual).map((user: any, index: any) => {
      return <>{((individual[user]?.callStatus !== "Removed") && (individual[user]?.callStatus !== "Disconnected")) && < li key={index} >
        {user.toString().length <= 3 ?
          <div className={`${(individual[user]?.callStatus === 'Unattended' || individual[user]?.callStatus === 'Rejected') && styles.inactiveParticipant} ${styles.lefts}`}>
            <URAvatarGroup className={`lefts size28 colorBG2  ${(individual[user]?.ImageURL !== null && individual[user]?.ImageURL !== "")?'avatarWithImg':''} ${styles.avatarname}`} profileInfo={
              (individual[user]?.ImageURL&&individual[user]?.ImageURL !== null && individual[user]?.ImageURL !== "") ?
                (<>
                  <img src={individual[user]?.ImageURL} alt="" />
                  <URStatusDot className={userStatusColor(individual[user]?.user_status, 'small')} /></>) :
                (<>
                  <label className={styles.usernametxtdot}>{individual[user]?.caller_id?.charAt(0).toUpperCase()} </label>
                  <URStatusDot className={userStatusColor(individual[user]?.user_status, 'small')} />
                </>)
            } />

            <label className={styles.usernametxtdot}> {(loggeduser?.ext.toString() === user.toString()) ? 'You' :individual[user]?.caller_id || user}</label>
            {(activeCallDetail?.isHostId).toString() === user.toString() && <span className={styles.hosts}>(host)</span>}
            {(individual[user]?.UserDeviceType==="URDESK:"&&individual[user]?.callStatus === "Connected") && <img src={deskImg} className={styles.hosts} alt="" />}

            {(!isSplitView && individual[user]?.underGroups?.length > 0) &&
              <Tooltip placement="top" title={individual[user]?.underGroups.join(",")}>
                <span className={styles.countof}>{individual[user]?.underGroups?.length}</span>
              </Tooltip>}
          </div> :

          <div className={`${(individual[user]?.callStatus === 'Unattended' || individual[user]?.callStatus === 'Rejected') && styles.inactiveParticipant} ${styles.lefts}`}>
            <img src={callred} className={styles.nonamescall} />
            {user}
          </div>
        }

<div className={`${styles.rights} ${styles.hovercalshow}`}>
          <>

            {activeCallDetail?.isGroupHost ?
              <>
                {individual[user]?.hold === 'Hold' ?
                  <><button className={`${styles.callAgain} ${styles.holdtop}`}>Hold</button>
                  </>

                  :
                  <>
                    {(individual[user]?.callStatus === "Dialing" || individual[user]?.callStatus === "Ringing") && <span className={`dailleft ${styles.status}`}>{individual[user]?.callStatus}...</span>}
                    {(individual[user]?.callStatus === 'Unattended' || individual[user]?.callStatus === 'Rejected') && <button className={`${styles.callAgain}`} onClick={() => singleSendFramer('Call', user)}>call</button>}

                    {(individual[user]?.callStatus === 'Connected'&&user !== activeCallDetail?.isHostId &&individual[user]?.UserDeviceType !== "URDESK:")
                   && <button className={styles.muteCall} onClick={() => groupSendFramer((individual[user]?.mute === 'mute' ? 'unmute' : 'mute'), false, user, true)}> {individual[user]?.mute === 'mute' ? 'Unmute' : 'Mute'}</button>}

                  </>}

                {(individual[user]?.callStatus === "Ringing") && <button className={styles.endCall} onClick={() => groupSendFramer('Remove', false, user, true)}>End</button>}
                {(individual[user]?.callStatus === 'Connected' && user !== activeCallDetail?.isHostId) &&

                  <Dropdown overlay={
                    <Menu className="menufiletersmute">
                      {(user.toString().length <=3 && individual[user].UserDeviceType!=="URDESK:")&& <Menu.Item key={"All"} onClick={() => directAssign(user)}>Assign as host</Menu.Item>}
                      <Menu.Item key={"Missed"} onClick={() => groupSendFramer('Remove', false, user, true)}>Remove Participants <span className={`icon_receiverfill righticonpro`}></span></Menu.Item>
                    </Menu>
                  } placement="bottomRight" trigger={["click"]} >
                    <button className={styles.threedot} ><span className="icon_overflow-H"></span></button>
                  </Dropdown>}
              </>
              :
              <>
              {(individual[user]?.hold === 'Hold') ?
              <button className={`${styles.callAgain} ${styles.holdtop}`}>Hold</button>:

              (individual[user]?.callStatus !== "Connected") &&
              <span className={`dailleft ${styles.status}`}>{((individual[user]?.callStatus === "Dialing" || individual[user]?.callStatus === "Ringing") ? `${individual[user]?.callStatus}...` : individual[user]?.callStatus)}</span>}
              </>
            }

            {(individual[user]?.callStatus === 'Connected' && user.toString().length <= 3 && individual[user]?.hold !== 'Hold') &&

              (individual[user]?.mute === "mute" ?
                <span className={`icon_Unmute redbg micrightalign" ${styles.microicon}`} ></span>
                :
                individual[user]?.UserDeviceType === "URDESK:" ? <span className={`icon_microphone micrightalign ${styles.microiconright}`} ></span>
                  : (!individual[user].isSpeaking ? (
                    <div className={`${'dotElastic'}`}>
                      <div className="dotheight"></div>
                      <div className="dotheight" ></div>
                      <div className="dotheight"></div>
                      <div className="dotheight"></div>
                      <div className="dotheight"></div>
                    </div>)
                    :
                    (<object data={waveImg} type="image/svg+xml"> ... </object>)))
            }
          </>
        </div>
      </li >
      }</>
    })

    }











         






          
        </ul>}
      </>
    })
  }

  const participantListComp = () => {
    let directView: any = isSplitView ? IndividualRender : RenderJoined;
    return Object?.keys(directView).map((key: any, index: any) => {
      return <>{((directView[key]?.callStatus !== "Removed") && (directView[key]?.callStatus !== "Disconnected")) && < li key={index} >
        {key.toString().length <= 3 ?
          <div className={`${(directView[key]?.callStatus === 'Unattended' || directView[key]?.callStatus === 'Rejected') && styles.inactiveParticipant} ${styles.lefts}`}>
            <URAvatarGroup  className={`lefts size28 colorBG2  ${(directView[key]?.ImageURL !== null && directView[key]?.ImageURL !== "")?'avatarWithImg':''} ${styles.avatarname}`} profileInfo={
              (directView[key]?.ImageURL&&directView[key]?.ImageURL !== null && directView[key]?.ImageURL !== "") ?
                (<>
                  <img src={directView[key]?.ImageURL} alt="" />
                  <URStatusDot className={userStatusColor(directView[key]?.user_status, 'small')} /></>) :
                (<>
                  <label className={styles.usernametxtdot}><span>{directView[key]?.caller_id?.charAt(0).toUpperCase()} </span></label>
                  <URStatusDot className={userStatusColor(directView[key]?.user_status, 'small')} />
                </>)
            } />

            <label className={styles.usernametxtdot}> {(loggeduser?.ext.toString() === key.toString()) ? 'You' : directView[key]?.caller_id || key}</label>
            {(activeCallDetail?.isHostId).toString() === key.toString() && <span className={styles.hosts}>(host)</span>}
            {(directView[key]?.UserDeviceType==="URDESK:" &&(directView[key]?.callStatus === "Connected"))&&<img src={deskImg} className={styles.hosts} alt="" />}
            {((directView[key]?.callStatus === "Connected")&&(key.toString()).length>3)&&<img src={pstnImg} className={styles.pstnIcn} alt="" />}


            {(!isSplitView && directView[key]?.underGroups?.length > 0) &&
              <Tooltip placement="top" title={directView[key]?.underGroups.join(",")}>
                <span className={styles.countof}>{directView[key]?.underGroups?.length}</span>
              </Tooltip>}
          </div> :

          <div className={`${(directView[key]?.callStatus === 'Unattended' || directView[key]?.callStatus === 'Rejected') && styles.inactiveParticipant} ${styles.lefts}`}>
            <img src={callred} className={styles.nonamescall} />
            {key}
            {((directView[key]?.callStatus === "Connected")&&(key.toString()).length>3)&&<img src={pstnImg} className={styles.pstnIcn} alt="" />}
          </div>
        }
        <div className={`${styles.rights} ${styles.hovercalshow}`}>
          <>

            {activeCallDetail?.isGroupHost ?
              <>
                {directView[key]?.hold === 'Hold' ?
                  <><button className={`${styles.callAgain} ${styles.holdtop}`}>Hold</button>
                  </>

                  :
                  <>
                    {(directView[key]?.callStatus === "Dialing" || directView[key]?.callStatus === "Ringing") && <span className={`dailleft ${styles.status}`}>{directView[key]?.callStatus}...</span>}
                    {(directView[key]?.callStatus === 'Unattended' || directView[key]?.callStatus === 'Rejected') && <button className={`${styles.callAgain}`} onClick={() => singleSendFramer('Call', key)}>call</button>}
                    {(directView[key]?.callStatus === 'Connected' &&key !== activeCallDetail?.isHostId&& directView[key]?.UserDeviceType !== "URDESK:")&&directView[key]?.mute !== 'mute' && <button className={styles.muteCall} onClick={() => groupSendFramer((directView[key]?.mute === 'mute' ? 'unmute' : 'mute'), false, key, true)}> {directView[key]?.mute === 'mute' ? 'Unmute' : 'Mute'}</button>}
                  </>}

                {(directView[key]?.callStatus === "Ringing") && <button className={styles.endCall} onClick={() => groupSendFramer('Remove', false, key, true)}>End</button>}

                {(directView[key]?.callStatus === 'Connected' && key !== activeCallDetail?.isHostId) &&

                  <Dropdown overlay={
                    <Menu className="menufiletersmute">
                      {(key.toString().length <= 3 &&directView[key].UserDeviceType!=="URDESK:")&& <Menu.Item key={"All"} onClick={() => directAssign(key)}>Assign as host</Menu.Item>}
                      <Menu.Item key={"Missed"} onClick={() => groupSendFramer('Remove', false, key, true)}>Remove Participants <span className={`icon_receiverfill righticonpro`}></span></Menu.Item>
                    </Menu>
                  } placement="bottomRight" trigger={["click"]} >
                    <button className={styles.threedot} ><span className="icon_overflow-H"></span></button>
                  </Dropdown>}
              </>
              :
              <>
              {(directView[key]?.hold === 'Hold') ?
              <button className={`${styles.callAgain} ${styles.holdtop} ${styles.holduserright}`}>Hold</button>:

              (directView[key]?.callStatus !== "Connected") &&
              <span className={`dailleft ${styles.status}`}>{((directView[key]?.callStatus === "Dialing" || directView[key]?.callStatus === "Ringing") ? `${directView[key]?.callStatus}...` : directView[key]?.callStatus)}</span>}
              </>
            }

            {(directView[key]?.callStatus === 'Connected' && key.toString().length <= 3 && directView[key]?.hold !== 'Hold' && directView[key]?.UserDeviceType!=="URDESK:") &&

              (directView[key]?.mute === "mute" ?
                <span className={`icon_Unmute redbg micrightalign" ${styles.microicon}`} ></span>
                :
               (!directView[key].isSpeaking ? (
                  <div className={`${'dotElastic'}`}>
                    <div className="dotheight"></div>
                    <div className="dotheight" ></div>
                    <div className="dotheight"></div>
                    <div className="dotheight"></div>
                    <div className="dotheight"></div>
                  </div>)
                  :
                  (<object data={waveImg} type="image/svg+xml"> ... </object>))
              )}
          </>
        </div>
      </li >
      }</>
    });
  }


  const pstnListComp = () => {
    return Object?.keys(PSTNRender).map((key: any, index: any) => {
      return <>{((PSTNRender[key]?.callStatus !== "Removed") && (PSTNRender[key]?.callStatus !== "Disconnected")) &&
        <li key={index}  className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>
          <div className={`${(PSTNRender[key]?.callStatus === 'Unattended' || PSTNRender[key]?.callStatus === 'Rejected') && styles.inactiveParticipant} ${styles.lefts}`}>
            <img src={callred} className={styles.nonamescall} />
            {key}
          {((PSTNRender[key]?.callStatus === "Connected")&&(key.toString()).length>3)&&<img src={pstnImg} className={styles.pstnIcn} alt="" />}
          </div>
          <div className={styles.rights}>
            <>
              {PSTNRender[key]?.hold === 'Hold' ?
                <><button className={`${styles.callAgain} ${styles.holdtop}`}>Hold</button>
                <Dropdown overlay={
                  <Menu className="menufiletersmute">
                    <Menu.Item key={"Missed"} onClick={() => groupSendFramer('Remove', false, key, true)}>Remove Participants <span className={`icon_receiverfill righticonpro`}></span></Menu.Item>
                  </Menu>
                } placement="bottomRight" trigger={["click"]} >
                  <button className={styles.threedot} ><span className="icon_overflow-H"></span></button>
                </Dropdown>
                </>
                :
                (
                  <>
                    {activeCallDetail?.isGroupHost ?
                      <>
                        <button className={styles.endCall} onClick={() => groupSendFramer('Remove', false, key)}>End</button>

                        {(PSTNRender[key].callStatus === "Dialing" || PSTNRender[key].callStatus === "Ringing") && <span className={styles.status}>{PSTNRender[key].callStatus}...</span>}

                        {(PSTNRender[key]?.callStatus === 'Unattended' || PSTNRender[key]?.callStatus === 'Rejected') ?
                          <button className={styles.callAgain} onClick={() => singleSendFramer('Call', key)}>Call</button> :
                          <button className={styles.endCall} onClick={() => groupSendFramer('Remove', false, key)}>End</button>}
                      </>
                      :
                      <span className={styles.status}>{((PSTNRender[key].callStatus === "Dialing" || PSTNRender[key].callStatus === "Ringing") && `${PSTNRender[key].callStatus}...`)}</span>
                    }
                  </>
                )
              }
            </>
          </div>

          {/* {activeCallDetail?.isGroupHost &&
            <>
              {(IndividualRender[key]?.callStatus === 'Unattended' || IndividualRender[key]?.callStatus === 'Rejected') ?
                <button className={styles.callAgain} onClick={() => singleSendFramer('Call', key)}>Call</button> :
                <button className={styles.endCall} onClick={() => groupSendFramer('Remove', false, key)}>End</button>}
            </>
          } */}
        </li>
      }
      </>
    });
  }



  const invitedComp = () => {
    return Object?.keys(RenderInvited).map((key: any, index: any) => {
      return <>{((RenderInvited[key]?.callStatus !== "Removed") && (RenderInvited[key]?.callStatus !== "Disconnected")) &&
        <li key={index}  className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>

          <div className={`${styles.lefts} ${styles.inactiveParticipant} ${styles.hovercalshow}`}>
            <URAvatarGroup  className={`lefts size28 colorBG2  ${(RenderInvited[key]?.ImageURL !== null && RenderInvited[key]?.ImageURL !== "")?'avatarWithImg':''} ${styles.avatarname}`} profileInfo={
              (RenderInvited[key]?.ImageURL !== null && RenderInvited[key]?.ImageURL !== "") ?
                (<>
                  <img src={RenderInvited[key]?.ImageURL} alt="" />
                  <URStatusDot className={userStatusColor(RenderInvited[key]?.user_status, 'small')} /></>) :
                (<>
                  <label> <span>{RenderInvited[key]?.caller_id?.charAt(0).toUpperCase()}</span> </label>
                  <URStatusDot className={userStatusColor(RenderInvited[key]?.user_status, 'small')} />
                </>)
            } />
            <label className={styles.usernametxtdot}>{RenderInvited[key]?.caller_id}
              {(activeCallDetail?.isHostId).toString() === key.toString() && <span className={styles.hosts}>(host)</span>}</label>
           {RenderInvited[key]?.underGroups?.length>0&& <span className={styles.countof}>{RenderInvited[key]?.underGroups?.length}</span>}
          </div>


          <div className={`${styles.rights} ${styles.hovercalshow}`}>
            {activeCallDetail?.isGroupHost &&
            <button className={styles.callAgain} onClick={() => singleSendFramer('Call', key)}>Call</button>}
          </div>
        </li>
      }
      </>
    });
  }

  const change = (val: any, obj: any) => {
    setState({
      ...state, internalUsers: val,
      allContacts: searchableContact
    });
  };

  const searchContact = (e: any) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
      let filtered = _.filter(searchableContact, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
      });
      setState({ ...state, allContacts: filtered, searchText: searchName });
    }
    else { setState({ ...state, allContacts: searchableContact, searchText: '' }); }
  }



  const addCall = () => {
    if (internalUsers.length === 0 && externalUsers.length === 0) {
      /* 
      Array.isArray()
      */
      toastInformation('Please choose any Content')
    }
    else {
      sendAddParticipantToSocket(internalUsers, externalUsers);
    }
    closeAddCall();
  }
  const handleNumbers = (value: any) => {
    setState({ ...state, externalUsers: value });
  }

  const closeAddCall = () => {
    setState({ ...state, internalUsers: [], externalUsers: [], searchText: '' });
    setAddCall(false)
  }

  const filtermenu = (
    <Menu className="menufileters">
      <Menu.Item key={"All"}>All</Menu.Item>
      <Menu.Item key={"Missed"}>Missed</Menu.Item>
      <Menu.Item key={"Incoming"}>Incoming</Menu.Item>
      <Menu.Item key={"Outgoing"}>Outgoing</Menu.Item>
    </Menu>
  );

  const splitLayout = () => {
    setState({ ...state, isSplitView: !isSplitView });
  }

  return (
    <>
      <div className={`${styles.teamparticipants} scrollhover`}>
        <div className={styles.participantright}>

          {/* <button onClick={sendSoc}>attend</button> */}
          <div className={styles.participanttop}>
            {isAddCall && <div>
              <div className={styles.addcalling}>
                <h2>Add Call<br /><span>{externalUsers.length + internalUsers.length} Participant added</span></h2><span className={`icon_close ${styles.cursorTop}`} onClick={closeAddCall} />

              </div>

              <div className={styles.rightsidebar}>
                <div className={styles.middlelayers}>
                  <label>Contacts</label>
                  <div className={styles.insideicon}>
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      filterOption={false}
                      showSearch={true}
                      value={internalUsers}
                      defaultValue={internalUsers}
                      onSearch={searchContact}
                      placeholder="Enter name or extension"
                      onChange={change}
                    >
                      {MemberLists(searchText, allContacts, true)}
                    </Select>
                  </div>

                  <label>Phone Number</label>
                  <Select
                    mode="tags"
                    style={{ width: '100%' }}
                    showSearch={false}
                    value={externalUsers}
                    placeholder="Type numbers separated by space"
                    dropdownClassName={`hoverbdrBlue  ${styles.normalinput}`}
                    onChange={handleNumbers}
                    tokenSeparators={[' ', ',']}
                    filterOption={false}>
                  </Select>

                </div>
              </div>
              <div className={`${styles.footesplicersection} ${styles.addbtnfooter} ${"footersection"} padlrzero `}>
                <URButton className="urButton buttonBlue marlftmin" name="Add Call " onClick={addCall}></URButton>
              </div>
            </div>}
            {activeCallDetail?.isGroupCall ? <h3>Participants({totalGroupParticipants})</h3> : <h3>Participants</h3>}
            <URInput placeHolder="Search Participants" className="leftbarsearch" onChange={(e: any) => setState({ ...state, searchActive: e.target.value })}></URInput>

          </div>
          <div className={styles.participantmid}>
            {!activeCallDetail?.isGroupCall ?
              (
                <ul  className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>
                  {searchedList?.map((user: any, index: any) => {
                    let callerId: string = '';
                    if (user?.caller_id !== 'Unknown Caller' && user?.caller_id !== '') {
                      callerId = user?.caller_id;
                    }
                    else {
                      callerId = (user?.bound === 'OUT') ? user.to : user.from;
                    }
                    return <li key={index} value={user.guid}>
                      <div className={styles.lefts}>
                        <URAvatarGroup className={`${'lefts size2'} ${styles.avatarname}`} profileInfo={user?.contact?.ImageURL && user?.contact?.ImageURL !== "" ? <>
                          <img src={user?.contact?.ImageURL} alt="" /></> : <><span>{callerId?.charAt(0).toUpperCase()}</span></>} />
                        {callerId}
                      </div>
                      <div className={styles.rights}>
                        {/* <span className="icon_microphone"></span> */}
                        {/* <button className={styles.callAgain} >Hold</button> */}
                      </div>
                    </li>
                  })}
                </ul>
              )
              :
              (isSplitView ?

                <>
                  {groupUserCount > 0 && groupCallComponent()}
                  {(IndividualUserCount > 0 || PSTNUserCount > 0) &&
                    <>
                      <div className={styles.listheader} onClick={(e: any) => handleDropdowns('other')}>
                        <div className={styles.leftconsectxt}>
                          <span className={dropDowns.includes('other') ? "icon_expandarrow" : "icon_uparrow"}></span>Other Participant   <label className={styles.userCountno}>({IndividualUserCount + PSTNUserCount})
                          </label>
                        </div>


                      </div>
                      {!(dropDowns.includes('other')) && <ul className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>
                        {participantListComp()}
                        {pstnListComp()}
                      </ul>}
                    </>
                  }
                </>
                : <>
                  <div className={styles.participantmid}>


                    <div className={styles.listheader} onClick={(e: any) => handleDropdowns('joined')}>
                      <div className={styles.leftconsectxt}> <span className={dropDowns.includes('joined') ? "icon_expandarrow" : "icon_uparrow"}></span>Joined<label className={styles.userCountno}>({joinedCount})
                      </label></div>
                    </div>
                    {!(dropDowns.includes('joined'))  && <ul className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>{participantListComp()}</ul>}


                   { invitedCount>0&& <div className={styles.listheader} onClick={(e: any) => handleDropdowns('invited')}>
                      <div className={styles.leftconsectxt}><span className={dropDowns.includes('invited') ? "icon_expandarrow" : "icon_uparrow"}></span>Invited
                        <label className={styles.userCountno}>({invitedCount}) </label></div>


                    </div>}


                    {!(dropDowns.includes('invited')) && <ul  className={!(activeCallDetail?.isGroupHost)?styles.hovernone:""}>{invitedComp()}</ul>}


                    {/* {!(dropDowns.includes('other')) && <ul>
                        {participantListComp()}
                        {pstnListComp()}
                      </ul> */}


                  </div>
                </>

              )
            }
          </div>
          {/* <div className={styles.participantmid}>
            <h4 onClick={(e: any) => handleDropdowns('other')}>
              <span className={dropDowns.includes('other') ? "icon_expandarrow" : "icon_uparrow"}></span>Invited   <label className={styles.userCountno}>({IndividualUserCount + PSTNUserCount})
              </label></h4>
            <ul>
            {invitedComp()}
            </ul>
          </div> */}



          {/* 
          <div className={styles.participanttop}>
                   <h3>Participants <Tooltip title="Mute All"><span className="icon_microphone"></span></Tooltip></h3>
                  <URInput placeHolder="Search Participants" className="leftbarsearch"></URInput>
                </div>
                <div className={styles.participantmid}>
                  <ul>
                    <li>
                        <div className={styles.lefts}>
                          <URAvatarGroup className={`${'lefts size28'} ${styles.avatarname}`} profileInfo={<><span>A</span></>} />
                          Kevin Ross <span className={styles.hosts}>(Host)</span>
                        </div>
                        <div className={styles.rights}>
                          <span className="icon_translation"></span>
                        </div>
                    </li>
                    <li>
                        <div className={styles.lefts}>
                          <URAvatarGroup className={`${'lefts size28'} ${styles.avatarname}`} profileInfo={<><span>A</span></>} />
                          Kevin Ross
                        </div>
                        <div className={styles.rights}>
                          <span className="icon_microphone"></span>
                        </div>
                    </li>
                  </ul>

                  <h4><span className="icon_expandarrow"></span>UX Designers Team (4)</h4>
                  <ul>
                    <li>
                        <div className={styles.lefts}>
                          <URAvatarGroup className={`${'lefts size28'} ${styles.avatarname}`} profileInfo={<><span>A</span></>} />
                          Kevin Ross
                        </div>
                        <div className={styles.rights}>
                          <span className="icon_microphone"></span>
                        </div>
                    </li>
                    <li>
                        <div className={styles.lefts}>
                          <URAvatarGroup className={`${'lefts size28'} ${styles.avatarname}`} profileInfo={<><span>A</span></>} />
                          Kevin Ross
                        </div>
                        <div className={styles.rights}>
                          <span className="icon_microphone"></span>
                        </div>
                    </li>
                  </ul>
                </div> */}
        </div>
      </div>
{activeCallDetail?.isGroupCall&&
      <Row justify="center" className={styles.participantBottom}>
        <Space>
          {activeCallDetail?.isGroupHost &&
            <>
              {/* {activeCallDetail?.isMuteAll ?

                (<URButton className="urButton buttonWhite bluebg" name='Unmute All' onClick={() => removeAllnMuteAll('unmuteAll', activeCallDetail?.guid)} />) : */}
                <URButton className="urButton buttonWhite bluebg" name='Mute All' onClick={() => removeAllnMuteAll('muteAll', activeCallDetail?.guid)} />
                
            </>
          }
          <URButton className="urButton buttonWhite bluebg" name={isSplitView ? 'Default View' : 'Split as Group'} onClick={splitLayout} />
        </Space>
      </Row>}
      <Modal visible={openAssign} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeAssign} />
        <h2> Can&apos;t Connect</h2>
        <p>
          If you start a new call, the current call will be on hold for you but the participants continue with the
          call. Are you okay to continue?
        </p>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} name="Cancel" onClick={closeAssign}></URButton>
          <URButton className={styles.okaybtn} onClick={assignHost} name="Okay"></URButton>
        </div>
      </Modal>
    </>
  );
}